/* MAGNOLIA STUDIO - theme.js */
(function () {
  'use strict';

  var CFG = window.MAGNOLIA || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function formatMoney(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}';
    var n = (cents || 0) / 100;
    function withSep(value, dec, thousands) {
      var parts = value.toFixed(2).split('.');
      var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return int + dec + parts[1];
    }
    function noDec(value, thousands) {
      return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return withSep(n, '.', ',');
        case 'amount_no_decimals': return noDec(n, ',');
        case 'amount_with_comma_separator': return withSep(n, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return noDec(n, '.');
        case 'amount_with_space_separator': return withSep(n, ',', ' ');
        case 'amount_no_decimals_with_space_separator': return noDec(n, ' ');
        case 'amount_with_apostrophe_separator': return withSep(n, '.', "'");
        default: return withSep(n, '.', ',');
      }
    });
  }

  function openMenu() {
    var p = $('#menuPanel'), o = $('#menuOverlay');
    if (p) p.classList.add('open');
    if (o) o.classList.add('open');
    document.body.classList.add('no-scroll');
  }
  function closeMenu() {
    var p = $('#menuPanel'), o = $('#menuOverlay');
    if (p) p.classList.remove('open');
    if (o) o.classList.remove('open');
    document.body.classList.remove('no-scroll');
  }
  window.openMenu = openMenu;
  window.closeMenu = closeMenu;

  function openCart() {
    var d = $('#cartDrawer'), o = $('#cdOverlay');
    if (!d) return;
    d.classList.add('open');
    d.setAttribute('aria-hidden', 'false');
    if (o) o.classList.add('open');
    document.body.classList.add('no-scroll');
  }
  function closeCart() {
    var d = $('#cartDrawer'), o = $('#cdOverlay');
    if (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); }
    if (o) o.classList.remove('open');
    document.body.classList.remove('no-scroll');
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); });
  }

  function addToCart(formData) {
    return fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); });
  }

  function updateBubble(count) {
    $$('.cart-count').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
  }

  function shipIcon() {
    return '<svg class="cd-truck" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
      '<path d="M1 6h12v9H1z"/><path d="M13 9h4l3 3v3h-7z"/><circle cx="5.5" cy="17.5" r="1.8"/><circle cx="16.5" cy="17.5" r="1.8"/></svg>';
  }

  function renderCart(cart) {
    var items = $('#cdItems');
    if (!items) return;

    $('#cdCount').textContent = cart.item_count;
    updateBubble(cart.item_count);
    $('#cdEmpty').hidden = cart.item_count > 0;
    $('#cdFoot').hidden = cart.item_count === 0;

    var ship = $('#cdShip');
    var eg = CFG.envioGratis || {};
    if (ship && eg.activo && eg.monto > 0 && cart.item_count > 0) {
      ship.hidden = false;
      var total = cart.total_price;
      var falta = eg.monto - total;
      var pct = Math.min(100, (total / eg.monto) * 100);
      $('#cdBarFill').style.width = pct + '%';
      $('#cdBarNow').textContent = formatMoney(total);
      $('#cdBarGoal').textContent = formatMoney(eg.monto);
      if (falta > 0) {
        $('#cdShipTxt').innerHTML = shipIcon() + (eg.texto || '').replace('[MONTO]', '<strong>' + formatMoney(falta) + '</strong>');
        ship.classList.remove('done');
      } else {
        $('#cdShipTxt').innerHTML = shipIcon() + '<strong>' + (eg.logrado || 'Tenes envio gratis') + '</strong>';
        ship.classList.add('done');
      }
    } else if (ship) {
      ship.hidden = true;
    }

    items.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      var opts = (it.options_with_values || [])
        .filter(function (o) { return o.value && o.value !== 'Default Title'; })
        .map(function (o) { return o.value; }).join(', ');
      var discs = (it.line_level_discount_allocations || [])
        .map(function (d) { return '<p class="cd-item-disc">' + d.discount_application.title + '</p>'; }).join('');
      var precio = it.original_line_price !== it.final_line_price
        ? '<span class="cd-now">' + formatMoney(it.final_line_price) + '</span> <s class="cd-was">' + formatMoney(it.original_line_price) + '</s>'
        : '<span class="cd-now">' + formatMoney(it.final_line_price) + '</span>';
      return '' +
        '<div class="cd-item" data-key="' + it.key + '">' +
          '<a class="cd-item-img" href="' + it.url + '">' + (img ? '<img src="' + img + '" alt="">' : '') + '</a>' +
          '<div class="cd-item-info">' +
            '<a class="cd-item-title" href="' + it.url + '">' + it.product_title + '</a>' +
            (opts ? '<p class="cd-item-var">' + opts + '</p>' : '') +
            discs +
            '<p class="cd-item-price">' + precio + '</p>' +
            '<div class="cd-item-actions">' +
              '<div class="qty-box small">' +
                '<button type="button" class="qty-btn" data-cart-qty="-1" aria-label="Menos">−</button>' +
                '<input type="number" class="cd-qty-input" value="' + it.quantity + '" min="0" inputmode="numeric">' +
                '<button type="button" class="qty-btn" data-cart-qty="1" aria-label="Mas">+</button>' +
              '</div>' +
              '<button type="button" class="cd-trash" aria-label="Eliminar">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 7h16"/><path d="M9 7V5h6v2"/><path d="M6 7l1 13h10l1-13"/><path d="M10 11v6M14 11v6"/></svg>' +
              '</button>' +
            '</div>' +
          '</div>' +
          '<div class="cd-item-total">' + formatMoney(it.final_line_price) + '</div>' +
        '</div>';
    }).join('');

    $('#cdTotal').textContent = formatMoney(cart.total_price) + ' ' + (cart.currency || '');
  }

  function initGallery() {
    var main = $('#pdpMain');
    if (!main) return;
    var slides = $$('.pdp-slide', main);
    var thumbs = $$('.pdp-thumb');
    var idx = 0;
    function go(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      idx = i;
      slides.forEach(function (s, n) { s.classList.toggle('active', n === i); });
      thumbs.forEach(function (t, n) { t.classList.toggle('active', n === i); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.goto, 10)); }); });
    $$('.pdp-arrow', main).forEach(function (b) {
      b.addEventListener('click', function () { go(idx + parseInt(b.dataset.dir, 10)); });
    });
    var x0 = null;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) go(idx + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });
  }

  function initVariants() {
    var sel = $('#pdpVariantSelect');
    if (!sel) return;
    var opts = $$('option', sel);
    function sync() {
      var chosen = $$('.pdp-option').map(function (o) {
        var a = $('.pdp-swatch.active', o);
        return a ? a.dataset.value : null;
      });
      var match = opts.filter(function (op) {
        return chosen.every(function (v, i) { return v === null || op.dataset['opt' + i] === v; });
      })[0];
      if (!match) return;
      sel.value = match.value;
      $('#pdpPrice').textContent = match.dataset.price;
      var cmp = $('#pdpCompare'), off = $('#pdpOff');
      if (match.dataset.compare) { cmp.textContent = match.dataset.compare; cmp.hidden = false; off.hidden = true; }
      else { cmp.hidden = true; off.hidden = true; }
    }
    $$('.pdp-swatch').forEach(function (b) {
      b.addEventListener('click', function () {
        $$('.pdp-swatch[data-option-index="' + b.dataset.optionIndex + '"]').forEach(function (o) { o.classList.remove('active'); });
        b.classList.add('active');
        sync();
      });
    });
    $$('.pdp-option').forEach(function (o) {
      if (!$('.pdp-swatch.active', o)) { var f = $('.pdp-swatch', o); if (f) f.classList.add('active'); }
    });
    sync();
  }

  function initQty() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('.qty-btn[data-qty]');
      if (!b) return;
      var input = $('#pdpQty');
      if (!input) return;
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qty, 10));
    });
  }

  function initAccordions() {
    document.addEventListener('click', function (e) {
      var h = e.target.closest('.pdp-acc-head');
      if (!h) return;
      var body = h.nextElementSibling;
      var open = h.classList.toggle('open');
      body.classList.toggle('open', open);
      var sign = h.querySelector('span');
      if (sign) sign.textContent = open ? '−' : '+';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var mb = $('.menu-btn'); if (mb) mb.addEventListener('click', openMenu);
    var mo = $('#menuOverlay'); if (mo) mo.addEventListener('click', closeMenu);
    var mc = $('.menu-close'); if (mc) mc.addEventListener('click', closeMenu);

    var pc = $('.mini-close');
    if (pc) pc.addEventListener('click', function () { $('#miniPopup').classList.add('hidden'); });

    var cdClose = $('#cdClose'); if (cdClose) cdClose.addEventListener('click', closeCart);
    var cdOv = $('#cdOverlay'); if (cdOv) cdOv.addEventListener('click', closeCart);

    if (CFG.drawer !== false) {
      $$('a[href$="/cart"], a[href*="/cart?"], .js-cart-open').forEach(function (a) {
        a.addEventListener('click', function (e) {
          if (a.classList.contains('cd-checkout')) return;
          e.preventDefault();
          openCart();
          fetchCart();
        });
      });
    }

    var dh = $('#cdDiscHead');
    if (dh) dh.addEventListener('click', function () {
      var b = $('#cdDiscBody');
      var open = b.classList.toggle('open');
      dh.querySelector('span').textContent = open ? '−' : '+';
    });

    var itemsEl = $('#cdItems');
    if (itemsEl) {
      itemsEl.addEventListener('click', function (e) {
        var row = e.target.closest('.cd-item');
        if (!row) return;
        var key = row.dataset.key;
        var input = $('.cd-qty-input', row);
        var q = e.target.closest('.qty-btn[data-cart-qty]');
        if (q) {
          var next = Math.max(0, (parseInt(input.value, 10) || 1) + parseInt(q.dataset.cartQty, 10));
          row.classList.add('loading');
          changeLine(key, next);
          return;
        }
        if (e.target.closest('.cd-trash')) {
          row.classList.add('loading');
          changeLine(key, 0);
        }
      });
      itemsEl.addEventListener('change', function (e) {
        if (!e.target.classList.contains('cd-qty-input')) return;
        var row = e.target.closest('.cd-item');
        changeLine(row.dataset.key, Math.max(0, parseInt(e.target.value, 10) || 0));
      });
    }

    var form = $('#pdpForm');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (CFG.drawer === false) return;
        e.preventDefault();
        var btn = $('#pdpAdd');
        var label = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Agregando...';
        addToCart(new FormData(form)).then(function (res) {
          btn.disabled = false;
          btn.textContent = label;
          if (!res.ok) { alert(res.body.description || 'No se pudo agregar el producto.'); return; }
          openCart();
          fetchCart();
        }).catch(function () {
          btn.disabled = false;
          btn.textContent = label;
        });
      });
    }

    initGallery();
    initVariants();
    initQty();
    initAccordions();

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { updateBubble(c.item_count); renderCart(c); })
      .catch(function () {});
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); closeMenu(); }
  });
})();
